import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';

const Container = styled.div``;

const Title = styled.h3`
  ${fonts.helvetica['87-heavy-condensed']};
  margin-bottom: 5px;
  font-size: 16px;
  color: ${brand.black};

  @media ${from(Device.Tablet)} {
    font-size: 18px;
  }
`;

const Documents = styled.ul`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Document = styled.div`
  ${fonts.helvetica['63-medium-extended']};
  text-transform: uppercase;
  color: ${brand.red.base};
  font-size: 12px;
  display: flex;
  gap: 5px;
`;

const DocumentWrapper = styled.a`
  padding-bottom: 5px;

  @media ${from(Device.Tablet)} {
    font-size: 18px;
  }
`;

const DocumentName = styled.div`
  ${fonts.helvetica['55-roman']};
  font-size: 15px;
  color: ${brand.red.base};
  margin-bottom: auto;
`;

const DownloadIcon = styled.div`
  color: ${brand.red.base};

  svg {
    width: 12px;
  }
`;

const DownloadItem = styled.li`
  display: flex;
  flex-grow: 1;
  align-items: center;
  gap: 15px;
`;

export const ProductDocumentsStyles = {
  Container,
  Title,
  Documents,
  Document,
  DocumentName,
  DownloadIcon,
  DocumentWrapper,
  DownloadItem,
};
